__turbopack_context__.v({
  "cardTitle": "contactForm-module__KZGr3W__cardTitle",
  "contactCard": "contactForm-module__KZGr3W__contactCard",
  "contactIcon": "contactForm-module__KZGr3W__contactIcon",
  "contactItem": "contactForm-module__KZGr3W__contactItem",
  "contactText": "contactForm-module__KZGr3W__contactText",
  "container": "contactForm-module__KZGr3W__container",
  "content": "contactForm-module__KZGr3W__content",
  "description": "contactForm-module__KZGr3W__description",
  "formContainer": "contactForm-module__KZGr3W__formContainer",
  "formGroup": "contactForm-module__KZGr3W__formGroup",
  "header": "contactForm-module__KZGr3W__header",
  "input": "contactForm-module__KZGr3W__input",
  "leftColumn": "contactForm-module__KZGr3W__leftColumn",
  "select": "contactForm-module__KZGr3W__select",
  "submitBtn": "contactForm-module__KZGr3W__submitBtn",
  "textarea": "contactForm-module__KZGr3W__textarea",
  "title": "contactForm-module__KZGr3W__title",
});
